import { render, staticRenderFns } from "./CategoriesTree.vue?vue&type=template&id=e5851ebc&scoped=true&"
import script from "./CategoriesTree.vue?vue&type=script&lang=js&"
export * from "./CategoriesTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5851ebc",
  null
  
)

export default component.exports